module.exports = __webpack_public_path__ + "static/img/color_cloud.ea53982.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/activity/november/color_cloud.png
// module id = LRzA
// module chunks = 86